<template>
  <div class="onlitxswd">
    <div class="xswdtitl">相似问答</div>
    <ul>
      <li class="ellipsis" v-for="item in 5" :key="item">
        我之前打给他人的借条、但是把欠但是
      </li>
    </ul>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";
export default {
  components: {
    subTitle,
  },
};
</script>

<style lang="scss" scoped>
.onlitxswd {
  width: 100%;
  height: 100%;
  padding: 20px;
  
  .xswdtitl {
    font-size: 22px;
    color: #000000;
  }
  ul {
    li {
    margin-top: 22px;
      cursor: pointer;
      list-style: disc;
      list-style-position: inside;
      font-size: 14px;
      color: #666666;
      line-height: 14px;
      &:hover {
        color: #0465ea;
      }
    }
  }
}
</style>